import "./AnswerSidebarResource.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../../redux/features/appData";
import {
  getAppLogo,
  iconPath,
  Link,
  formatDate2,
  getDomainFromHostname,
} from "winslow-core";
import { getActivityLogoFilePathInMode } from "winslow-core";
import { selectSupportedApps } from "../../../redux/features/connectedApps/connectedAppsSlice";
import { handleCopyText } from "../../uiHelpers";
import config from "environment";

type AnswerSidebarResourceProps = {
  link: Link;
  collectionId: string;
  minimum?: boolean;
  showDrag?: boolean;
  showAIMenu?: boolean;
  allowContextMenu?: boolean;
  clickIsOpen?: boolean;
};

const TITLE_LENGTH = 80;

export const AnswerSidebarResource = ({
  link,
  collectionId,
  minimum = false,
  showDrag = false,
  showAIMenu = false,
  allowContextMenu = true,
  clickIsOpen = false,
}: AnswerSidebarResourceProps) => {
  const navigate = useNavigate();
  const storeUser = useSelector(selectUser);
  const supportedApps = useSelector(selectSupportedApps);
  const [xy, setXY] = useState<{ x: number; y: number } | null>(null);

  let appLogoPath = "";
  let appId = link ? link.appId : "";

  if (link && link.appId) {
    const logo = getAppLogo(
      link.appId,
      link.title,
      supportedApps,
      "-activity.svg"
    );

    appLogoPath = getActivityLogoFilePathInMode(
      logo,
      storeUser?.theme as ("light-mode" | "dark-mode") | undefined
    );
  }

  let title = ("" + (link && link.title)).substring(0, TITLE_LENGTH);
  title += title.length > TITLE_LENGTH - 1 ? "..." : "";

  const handleClick = () => {
    if (!clickIsOpen) {
      const redirectUrl = `${config.clientUrl}/collection/${collectionId}/resources/${link.linkRecordId}`;
      window.open(redirectUrl, "__new");
      return;
    }

    if (link && link.url) {
      window.open(link.url, "__new");
    }
  };

  const handleMouseMove = (event: React.MouseEvent) => {
    setXY({ x: event.clientX, y: event.clientY });
  };

  let parsed = null;
  try {
    parsed = new URL(link.url || "");
  } catch (err) {
    console.log("[AnswerSidebarResource] can't parse url: ", link.url);
    return null;
  }

  const domain = parsed ? getDomainFromHostname(parsed.hostname) : null;
  const showTime = "";

  return (
    <div
      className="answer-sidebar-resource"
      onClick={handleClick}
      onMouseMove={handleMouseMove}>
      {showDrag && (
        <div className="answer-sidebar-resource-drag">
          <img src={iconPath("drag_active.svg", storeUser)} alt="" />
        </div>
      )}
      <div
        className="answer-sidebar-resource-logo"
        onClick={(e) => {
          e.stopPropagation();
          navigate("/linktypes/" + appId);
        }}>
        <img src={appLogoPath} alt="" />
      </div>
      <div className="answer-sidebar-resource-title-and-star">
        <div className="answer-sidebar-resource-name">{title}</div>
        {(appId === "OTHER" || appId === "LINK_PDF") && link.url && (
          <div className="answer-sidebar-resource-url">
            <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.url}
            </a>
          </div>
        )}
      </div>

      <div className="answer-sidebar-resource-endcap">
        {!minimum && (
          <>
            <div
              className="answer-sidebar-resource-icons"
              onClick={(e) => {
                e.stopPropagation();
                const redirectUrl = `${config.clientUrl}/collection/${collectionId}/resources/${link.linkRecordId}`;
                handleCopyText(redirectUrl);
              }}>
              <img src={iconPath("copy.svg", storeUser)} alt="" />
            </div>
            {showTime && (
              <div className="answer-sidebar-resource-time">{showTime}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
